import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { ValuePickerComponent, ValuePickerModel } from "./value-picker.component";

@Injectable()
export class ValuePickerModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = (model: ValuePickerModel) =>
		this.modalController.create({
			id: ValuePickerComponent.modalId,
			component: ValuePickerComponent,
			componentProps: model,
			showBackdrop: true,
			cssClass: this.rideOpsUi.isV2Active() ? "value-picker-modal-v2" : undefined,
		});
}
